export var ELMO_SVG_ICONS_STORAGE_KEY = 'elmo-menu-svg-icons';
export var ELMO_SVG_ICONS_S3_STAGING = 'https://assets.cdn.elmodev.com/svg-icons.svg';
export var ELMO_SVG_ICONS_S3_PRODUCTION = 'https://assets.cdn.elmotalent.com.au/svg-icons.svg';
export var ELMO_SVG_EXPIRY_TIME = 7200000; // 2hours
